import { render, staticRenderFns } from "./customer-selection.vue?vue&type=template&id=3412da18"
import script from "./customer-selection.vue?vue&type=script&lang=js"
export * from "./customer-selection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports